import React from 'react';
import { PromoBar } from '../components/PromoBar';
import { Hero } from '../components/Hero';
import { ProofStrip } from '../components/ProofStrip';
import { PainSection } from '../components/PainSection';
import { SystemSection } from '../components/SystemSection';
import { VolumesSection } from '../components/VolumesSection';
import { BonusSection } from '../components/BonusSection';
import { OfferSection } from '../components/OfferSection';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FaqSection } from '../components/FaqSection';
import { BeforeAfterSection } from '../components/BeforeAfterSection';
import { FinalSection } from '../components/FinalSection';
import { SiteFooter } from '../components/SiteFooter';
export function Landing() {
  return <div className="w-full bg-cream" data-id="element-283" data-mp="h6o06wyk5zam">
      <PromoBar data-id="element-284" data-mp="m6sd6d09cbw3" />
      <Hero data-id="element-285" data-mp="m8d7q2mknuty" />
      <main data-id="element-286" data-mp="m7v6ssoyssfp">
        <ProofStrip data-id="element-287" data-mp="m5h9ed6tb44z" />
        <PainSection data-id="element-288" data-mp="29s8ai76rmxn" />
        <SystemSection data-id="element-289" data-mp="2aabxzw6h3fl" />
        <VolumesSection data-id="element-290" data-mp="2blg40tjcd78" />
        <BonusSection data-id="element-291" data-mp="27xoj77ni0v5" />
        <OfferSection data-id="element-292" data-mp="3tgl7xhmbze02" />
        <TestimonialsSection data-id="element-293" data-mp="3tg1xsn2x9twl" />
        <GuaranteeSection data-id="element-294" data-mp="3tf0clps6zr15" />
        <FaqSection data-id="element-295" data-mp="3tio46je2u3d8" />
        <BeforeAfterSection data-id="element-296" data-mp="3pe81ss3o9e2r" />
        <FinalSection data-id="element-297" data-mp="3pfj5krx4altv" />
      </main>
      <SiteFooter data-id="element-298" data-mp="3pgku9z7236u2" />
    </div>;
}